export const REVIEWEE_NOMINATION = 'REVIEWEE_NOMINATION';
export const REVIEWEE_NOMINATION_WITHOUT_APPROVAL = 'REVIEWEE_NOMINATION_WITHOUT_APPROVAL';
export const MANAGER_NOMINATION = 'MANAGER_NOMINATION';
export const HR_NOMINATION = 'HR_NOMINATION';
